import React from 'react';
import queryString from 'query-string';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import LoginForm from './LoginForm';

const Login = ({ location, translate }) => {

  const api = new ServiceApi()
  const parameters = queryString.parse(location.search);

  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type) {
      return false;
    }
    return true;
  }

  document.body.className = 'uslink-oauth-body';
  document.title = 'UsLink';

  return (
    <div className="uslink-oauth">
      {
        _validateParams()
          ? <LoginForm
            api={api}
            location={location}
            parameters={parameters}
            translate={translate}
          />
          : <RequestLoginErrorMessage
            onlyMessage={true}
            message={translate('RequestLoginErrorMessage')}
          />
      }
    </div>
  );
}

export default Login;
